module.exports = {"publicUrl":"https://www.recordscreenvideo.com/","showCursorOptions":false,"showVideoFormat":true,"showMicrophoneAudio":false,"showResolutionPicker":false,"showShareStep":false,"showAds":false}


//////////////////
// WEBPACK FOOTER
// ./src/config/development.json
// module id = 772
// module chunks = 0